import './About.css';
import { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Container from 'react-bootstrap/Container';
import { ReactMarkdownWithPlugins } from "./../shared/ReactMarkdownWithPlugins.js";
import { Collapse, Button, Offcanvas } from 'react-bootstrap';
import { GoogleMap, Marker, MarkerClusterer, LoadScript } from '@react-google-maps/api';
import Footer from '../shared/Footer.js';
import { getUserInfo } from "./../shared/UserUtility.js";

function About() {
    const [aboutContent, setAboutContent] = useState(null);
    const [visitorContent, setVisitorContent] = useState(null);
    const [visitorStats, setVisitorStats] = useState(null);
    const [visitorTotal, setVisitorTotal] = useState(0);
    const [visitorsLocOpen, setVisitorsLocOpen] = useState(false);
    const [aboutAppOpen, setAboutAppOpen] = useState(false);

    const [userId, setUserId] = useState(null);
    getUserInfo().then(userInfo => {
        if (userInfo) {
            setUserId(userInfo.userId);
        }
    });

    fetch(process.env.REACT_APP_ABOUT_CONTENT_API_URL)
        .then(response => {
            if (response.ok) {
                response.text().then(message => setAboutContent(message));
            } else {
                response.text().then(message => {
                    if (message) {
                        console.log(message);
                    }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });

    useEffect(() => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: '04102025'
        };

        fetch(process.env.REACT_APP_VISITOR_API_URL, requestOptions)
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        let poi = [];
                        const countryCounts = {};

                        data.forEach((item) => {
                            let userLoc = item.userLoc && item.userLoc[0];
                            if (!userLoc) return;

                            // build poi for map markers
                            if (userLoc.loc) {
                                let poiJson = {}
                                poiJson['key'] = userLoc.ip;

                                let poiJsonLoc = {};
                                let splitLoc = userLoc.loc.split(',');
                                let lat = splitLoc[0];
                                let lng = splitLoc[1];
                                poiJsonLoc['lat'] = parseFloat(lat);
                                poiJsonLoc['lng'] = parseFloat(lng);
                                poiJson['location'] = poiJsonLoc;

                                poi.push(poiJson);
                            }

                            // aggregate by country (try different keys)
                            const country = userLoc.country || userLoc.country_name || userLoc.region || 'Unknown';
                            countryCounts[country] = (countryCounts[country] || 0) + 1;
                        });

                        // convert counts to sorted array
                        const stats = Object.entries(countryCounts).map(([country, count]) => ({ country, count }));
                        stats.sort((a, b) => b.count - a.count);

                        setVisitorContent(poi);
                        setVisitorStats(stats);
                        setVisitorTotal(data.length || poi.length);
                    });
                } else {
                    console.log(response.status + ' ' + response.statusText);
                    response.text().then(message => {
                        if (message) {
                            console.log(message);
                        }
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <>
            <div className="about-bg">
                <NavigationBar></NavigationBar>
                <Container style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <div>
                        {
                            !(aboutAppOpen) &&
                            <>
                                <div className="about-buttons-container">
                                    <Button
                                        className="about-button modern-button"
                                        variant="outline-dark"
                                        onClick={() => { setVisitorsLocOpen(!visitorsLocOpen) }}>
                                        <div className="button-content">
                                            <span className="button-icon">🌍</span>
                                            <span className="button-text">Visitors</span>
                                        </div>
                                    </Button>
                                </div>
                                <Offcanvas show={visitorsLocOpen} onHide={() => setVisitorsLocOpen(false)} placement="bottom" scroll={true} style={{ height: '85vh' }}>
                                    <Offcanvas.Header closeButton>
                                        <Offcanvas.Title>Visitors</Offcanvas.Title>
                                    </Offcanvas.Header>
                                    <Offcanvas.Body style={{ padding: 0 }}>
                                        <div style={{ height: '500px', width: '100%' }}>
                                            {
                                                !visitorContent &&
                                                <div className="visitor-loading-overlay">
                                                    <div className="text-center">
                                                        <div className="visitor-loading-text">
                                                            <em>Locating the visitors... may take about 5-10 seconds.</em>
                                                        </div>
                                                        <div className="lds-ellipsis">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}>
                                                <GoogleMap
                                                    mapContainerStyle={{ height: '500px', width: '100%' }}
                                                    center={{ lat: 39.8283, lng: -98.5795 }} // Center to USA
                                                    zoom={3}
                                                    options={{ mapId: process.env.REACT_APP_GOOGLE_MAP_ID }}
                                                >
                                                    <MarkerClusterer options={{ imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', gridSize: 60, maxZoom: 15 }}>
                                                        {(clusterer) =>
                                                            visitorContent &&
                                                            visitorContent.map((poi) => (
                                                                <Marker key={poi.key} position={poi.location} clusterer={clusterer} />
                                                            ))
                                                        }
                                                    </MarkerClusterer>
                                                </GoogleMap>
                                            </LoadScript>
                                        </div>
                                        {/* Visitor stats: show below the map when available */}
                                        {
                                            visitorStats && visitorStats.length > 0 &&
                                            <div className="visitor-stats-container" style={{ marginTop: '1rem', padding: '1rem' }}>
                                                <h5 style={{ marginBottom: '0.5rem' }}>Visitors by country — total: {visitorTotal}</h5>
                                                <div className="visitor-stats-list">
                                                    {
                                                        visitorStats.slice(0, 50).map((s) => (
                                                            <div className="visitor-stat-item" key={s.country}>
                                                                <span className="visitor-stat-country">{s.country}</span>
                                                                <span className="visitor-stat-count">{s.count}</span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </Offcanvas.Body>
                                </Offcanvas>
                            </>
                        }

                        {
                            !(visitorsLocOpen) && userId &&
                            <>
                                <div className="about-buttons-container">
                                    <Button
                                        className="about-button modern-button"
                                        variant="outline-dark"
                                        onClick={() => { setAboutAppOpen(!aboutAppOpen) }}>
                                        <div className="button-content">
                                            <span className="button-icon">📱</span>
                                            <span className="button-text">The App</span>
                                        </div>
                                    </Button>
                                </div>
                                <Collapse in={aboutAppOpen}>
                                    <div className="collapse-content about-content" style={{
                                        marginTop: "1rem",
                                        background: "rgba(255, 255, 255, .75)",
                                        padding: "20px",
                                        borderRadius: "20px"
                                    }}>
                                        {
                                            aboutContent &&
                                            <ReactMarkdownWithPlugins content={aboutContent}></ReactMarkdownWithPlugins>
                                        }
                                        {
                                            !aboutContent &&
                                            <>
                                                <div className="text-center">
                                                    <div className='text-muted'><em>Loading the content from backend...</em></div>
                                                    <div className="lds-ellipsis">
                                                        <div>
                                                        </div>
                                                        <div>
                                                        </div>
                                                        <div>
                                                        </div>
                                                        <div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </Collapse>
                            </>
                        }
                    </div>
                </Container>

                {
                    // when visitor stats are visible, add a spacer so footer is pushed below
                    visitorsLocOpen && visitorStats && visitorStats.length > 0 &&
                    <div aria-hidden="true" style={{ height: '110px', width: '100%' }} />
                }
                <Footer></Footer>
            </div>
        </>
    );
}

export default About;